import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export function verifyMfaTokenForLogin(request) {
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.put('/verifyMFATokenForLogin', request?.requestBody)
}
